export default __webpack_public_path__ + "static/media/dinas1.269c9506.png";